import { Parent, ParentDaycare, ParentWithChild } from '@/types/Parent.ts'
import { CreateChildRequestSlot } from '@/types/Slots.ts'
import { PlanningTabsState } from '@/hooks/usePlanningRights.ts'
import { ChangeEvent } from 'react'

export function parentHaveChildRequest(currentDaycareId: number, parent?: Parent): boolean {
    if (!parent || !parent.childs) return false

    let res: boolean = false

    parent.daycares
        .filter((daycare: ParentDaycare): boolean => daycare.daycareId === currentDaycareId)
        .map((daycare: ParentDaycare): void => {
            daycare.childs.map((child: ParentWithChild): void => {
                if (child.request) res = true
            })
        })

    return res
}

export function getChildsRequestSlot(currentDaycareId: number, parent?: Parent): CreateChildRequestSlot[] {
    if (!parent || !parent.childs) return []

    const res: CreateChildRequestSlot[] = []

    parent?.daycares
        .filter((daycare: ParentDaycare): boolean => daycare.daycareId === currentDaycareId)
        .map((daycare: ParentDaycare): void => {
            daycare.childs.map((child: ParentWithChild): void => {
                if (child.request) {
                    res.push({
                        childId: child.childId,
                        childName: child.firstname,
                        childComplement: child.complement
                    })
                }
            })
        })

    return res
}

export function changeTabAndResetFilters(
    planningTabs: PlanningTabsState,
    selectFilters: string[],
    setSelectFilters: (filters: string[]) => void,
    e: ChangeEvent<NonNullable<unknown>>,
    newValue: number
): void {
    planningTabs.handleTabChange(e, newValue)
    const newFilters: string[] = selectFilters.filter(
        (filter: string) => filter.startsWith('SECTION_') || filter.startsWith('CHILD_')
    )
    setSelectFilters(newFilters)
}
